(function () {
  const drawer = document.querySelector('[data-ps-search-drawer]');
  if (!drawer) return;

  const input = drawer.querySelector('[data-ps-search-input]');
  const results = drawer.querySelector('[data-ps-search-results]');
  const form = drawer.querySelector('[data-ps-search-form]');
  const toggles = document.querySelectorAll('[data-ps-search-toggle]');
  const closes = drawer.querySelectorAll('[data-ps-search-close]');

  let abortCtl = null;
  let timer = null;

  function el(tag, props, children) {
    const node = document.createElement(tag);
    if (props) {
      Object.keys(props).forEach(function (k) {
        if (k === 'class') node.className = props[k];
        else if (k === 'text') node.textContent = props[k];
        else if (k === 'href' || k === 'src' || k === 'alt' || k === 'loading' || k === 'aria-label') node.setAttribute(k, props[k]);
        else node.setAttribute(k, props[k]);
      });
    }
    if (children) {
      children.forEach(function (c) { if (c) node.appendChild(c); });
    }
    return node;
  }

  function emptyMessage(text) {
    const p = document.createElement('p');
    p.className = 'ps-search-drawer-empty';
    p.textContent = text;
    return p;
  }

  function emptyState() {
    const p = document.createElement('p');
    p.className = 'ps-search-drawer-empty';
    p.appendChild(document.createTextNode('start typing to search'));
    const dot = document.createElement('span');
    dot.className = 'dot';
    dot.textContent = '.';
    p.appendChild(dot);
    return p;
  }

  function clearResults(replacement) {
    while (results.firstChild) results.removeChild(results.firstChild);
    if (replacement) results.appendChild(replacement);
  }

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 100);
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    input.value = '';
    clearResults(emptyState());
    if (abortCtl) { abortCtl.abort(); abortCtl = null; }
    if (timer) { clearTimeout(timer); timer = null; }
  }

  toggles.forEach(function (t) { t.addEventListener('click', open); });
  closes.forEach(function (c) { c.addEventListener('click', close); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  function buildProductsGroup(products) {
    if (!products || !products.length) return null;
    const group = el('div', { class: 'ps-search-drawer-group' });
    group.appendChild(el('h3', { text: 'products' }));
    const grid = el('div', { class: 'ps-search-drawer-product-grid' });
    products.forEach(function (p) {
      const card = el('a', { class: 'ps-search-drawer-product', href: p.url || '#' });
      const imgWrap = el('div', { class: 'ps-search-drawer-product-img' });
      if (p.featured_image && p.featured_image.url) {
        imgWrap.appendChild(el('img', {
          src: p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400',
          alt: p.title || '',
          loading: 'lazy'
        }));
      }
      card.appendChild(imgWrap);
      const meta = el('div', { class: 'ps-search-drawer-product-meta' });
      meta.appendChild(el('div', { class: 'ps-search-drawer-product-name', text: (p.title || '').toLowerCase() }));
      if (p.price != null) meta.appendChild(el('div', { class: 'ps-search-drawer-product-price', text: String(p.price) }));
      card.appendChild(meta);
      grid.appendChild(card);
    });
    group.appendChild(grid);
    return group;
  }

  function buildList(items, heading) {
    if (!items || !items.length) return null;
    const group = el('div', { class: 'ps-search-drawer-group' });
    group.appendChild(el('h3', { text: heading }));
    const ul = el('ul', { class: 'ps-search-drawer-list' });
    items.forEach(function (i) {
      const li = el('li');
      li.appendChild(el('a', { href: i.url || '#', text: (i.title || '').toLowerCase() }));
      ul.appendChild(li);
    });
    group.appendChild(ul);
    return group;
  }

  function buildAllLink(q) {
    return el('a', { class: 'ps-search-drawer-all', href: '/search?q=' + encodeURIComponent(q), text: 'view all results →' });
  }

  function render(resources, q) {
    const r = resources && resources.results ? resources.results : {};
    const products = r.products || [];
    const articles = r.articles || [];
    const pages = r.pages || [];

    if (!products.length && !articles.length && !pages.length) {
      const p = document.createElement('p');
      p.className = 'ps-search-drawer-empty';
      p.appendChild(document.createTextNode('no results for '));
      const em = document.createElement('em');
      em.textContent = q;
      p.appendChild(em);
      p.appendChild(document.createTextNode('. try another word.'));
      clearResults(p);
      return;
    }

    const frag = document.createDocumentFragment();
    [buildProductsGroup(products), buildList(articles, 'journal'), buildList(pages, 'pages'), buildAllLink(q)].forEach(function (n) {
      if (n) frag.appendChild(n);
    });
    clearResults();
    results.appendChild(frag);
  }

  async function search(q) {
    if (abortCtl) abortCtl.abort();
    if (!q || q.length < 2) {
      clearResults(emptyState());
      results.classList.remove('is-loading');
      return;
    }
    abortCtl = new AbortController();
    results.classList.add('is-loading');
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,article,page'
        + '&resources[limit]=6'
        + '&resources[options][unavailable_products]=last';
      const res = await fetch(url, { signal: abortCtl.signal });
      const data = await res.json();
      results.classList.remove('is-loading');
      render(data.resources, q);
    } catch (err) {
      if (err && err.name !== 'AbortError') {
        results.classList.remove('is-loading');
        clearResults(emptyMessage('something went wrong. try again.'));
      }
    }
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { search(input.value.trim()); }, 220);
  });

  form.addEventListener('submit', function () { /* let browser navigate to /search?q=... */ });
})();
